import React, { Component } from 'react';
import ReactTimeout from 'react-timeout'

import './Notification.css';

class Notification extends Component {
  constructor(props) {
      super(props);

      this.close = this.close.bind(this);
      this._handleClose = this._handleClose.bind(this);
  }

  componentDidMount() {
    setTimeout(this.close, this.props.timeout);
  }

  close() {
    this.props.onClose();
  }

  _handleClose() {
    this.close();
  }

  render() {
      const { type, title, detail } = this.props;

      return(
        <div className={ `alert alert-dismissible alert-${type} alert--notify` }>
            <i className="alert-icon"></i>
            <h5 className="alert-title">{ title }</h5>
            <span className="alert-message">{ detail }</span>
            <button type="button" aria-hidden="true" className="alert--notify__close" onClick={ this._handleClose }><i className="zmdi zmdi-close"></i></button>
        </div>
      );
  }
}

export default Notification;


// WEBPACK FOOTER //
// ./src/_components/notification/Notification.jsx